import { render, staticRenderFns } from "./modalEditEmail.vue?vue&type=template&id=2b35f7e2&"
import script from "./modalEditEmail.vue?vue&type=script&lang=js&"
export * from "./modalEditEmail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports